import { ChangeEventHandler, FC, useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import { useDispatch, useStore } from 'react-redux'
import { ReactComponent as CloseIcon } from '../../assets/images/cancel-status.svg'
import { handleGetDocumentById } from '../../redux/actions/document.detail.action'
import { updateTransaction } from '../../redux/actions/transaction.edit.action'
import { RootReducers } from '../../redux/reducers'
import { LoadingOverlay } from '../loadingOverlay'
import classes from './ModalEditCustomerInfo.module.css'

interface ModalEditCustomerInfoProp {
  isOpen: boolean
  onClose?: () => void
}

const ModalEditCustomerInfo: FC<ModalEditCustomerInfoProp> = ({ isOpen, onClose }) => {
  const store = useStore<RootReducers>()
  const dispatch = useDispatch()
  const [updating, setUpdating] = useState(false)

  const setInitFormValue = () => {
    const document = store.getState().documentDetailReducer.documentModel

    return {
      insuredName: document?.insuredName,
      NB_PolicyNo: document?.NB_PolicyNo,
      planName: document?.planName,
      customerDOB: document?.customerDOB,
      sumAssured: document?.sumAssured,
      paymentFrequency: document?.paymentFrequency,
      customerMail: document?.customerMail,
      customerPhone: document?.customerPhone
    }
  }

  const [formValue, setFormValue] = useState(setInitFormValue())

  const isDisableBtnSubmit = formValue.NB_PolicyNo === ''

  const handleInputChange: ChangeEventHandler<HTMLInputElement | HTMLSelectElement> = e => {
    let value: any = e.target.value
    const name = e.target.name

    if (name === 'sumAssured') {
      const newValue = parseInt(value.replace(/,/g, ''))
      if (!isNaN(newValue)) {
        value = newValue
      }
    }

    if (name === 'NB_PolicyNo') {
      if (/^[A-Za-z0-9]+$/.test(value) === false && value !== '') {
        value = formValue[name]
      } else {
        value = value.toUpperCase()
      }
    }

    setFormValue(prev => ({ ...prev, [name]: value }))
  }

  const onSubmit = async () => {
    const documentId = store.getState().documentDetailReducer.documentModel?.id

    if (documentId) {
      setUpdating(true)
      try {
        await dispatch(updateTransaction(documentId, formValue, undefined))
        await dispatch(handleGetDocumentById(String(documentId)))
      } catch (error) {
        console.error(error)
      } finally {
        setUpdating(false)
        onClose?.()
      }
    }
  }

  useEffect(() => {
    if (isOpen) {
      setFormValue(setInitFormValue())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <ReactModal
      isOpen={isOpen}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(24, 48, 40, 0.9)'
        },
        content: {
          width: 700,
          height: 450,
          left: '50%',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          padding: 30,
          borderRadius: 8
        }
      }}
      ariaHideApp={false}
    >
      {updating && <LoadingOverlay />}
      <div className={classes.content}>
        <div className={classes.title}>
          แก้ไขข้อมูลกรมธรรม์ลูกค้า{' '}
          <button onClick={onClose} className={classes.btnClose}>
            <CloseIcon />
          </button>
        </div>

        <form className={classes.form}>
          <label className="group-label-input">
            <span>ชื่อ-สกุล ผู้เอาประกันภัย:</span>
            <input
              disabled={true}
              className={`field-input`}
              autoComplete="off"
              type="text"
              name="insuredName"
              value={formValue.insuredName}
              onChange={handleInputChange}
            />
          </label>

          <label className="group-label-input">
            <span>เลขที่กรมธรรม์รายใหม่:</span>
            <input
              required
              className={`field-input`}
              autoComplete="off"
              type="text"
              name="NB_PolicyNo"
              value={formValue.NB_PolicyNo}
              onChange={handleInputChange}
            />
          </label>

          {/* <label className="group-label-input">
            <span>แบบประกัน :</span>
            <input
              required
              className={`field-input`}
              autoComplete="off"
              type="text"
              name="planName"
              value={formValue.planName}
              onChange={handleInputChange}
            />
          </label>

          <label className="group-label-input">
            <span>วันเดือนปีเกิด(ค.ศ.) :</span>
            <WatDatePicker
              onChange={(christDate: any, buddhistDate: any) => {
                setFormValue(prev => ({ ...prev, customerDOB: christDate }))
              }}
              dateFormat={'yyyy-MM-dd'} // for set data purpose [using date-fns format](https://date-fns.org/v2.12.0/docs/format)
              displayFormat={'DD/MM/YYYY'} // for display purpose (using dayjs format)[https://day.js.org/docs/en/display/format]
              clearable={false} // true | false
              minDate={dayjs().add(-100, 'year')} // supported date as string
              maxDate={dayjs()} // also supported dayjs or moment
              readOnly={false} // true | false
              yearBoundary={99} // number of boundary ±X Year
              value={formValue.customerDOB}
            />
          </label>

          <label className="group-label-input">
            <span>จำนวนเงินเอาประกัน :</span>
            <NumberFormat
              allowNegative={false}
              thousandSeparator={true}
              prefix=""
              name="sumAssured"
              className="amount-input"
              inputMode="decimal"
              onChange={handleInputChange}
              autoComplete="off"
              decimalScale={0}
              value={formValue.sumAssured}
            />
          </label>

          <label className="group-label-input">
            <span>งวดการชำระราย :</span>
            <select
              className="field-input"
              name="paymentFrequency"
              placeholder="งวดการชำระ"
              value={formValue.paymentFrequency}
              onChange={handleInputChange}
            >
              <option value="">เลือก</option>
              <option value="ปี">ปี</option>
              <option value="6 เดือน">6 เดือน</option>
              <option value="3 เดือน">3 เดือน</option>
              <option value="เดือน">เดือน</option>
              <option value="ชำระครั้งเดียว">ชำระครั้งเดียว</option>
            </select>
          </label>

          <label className="group-label-input">
            <span>อีเมล :</span>
            <input
              required
              className={`field-input`}
              autoComplete="off"
              type="email"
              name="customerMail"
              value={formValue.customerMail}
              onChange={handleInputChange}
            />
          </label>

          <label className="group-label-input">
            <span>เบอร์โทรศัพท์ :</span>
            <input
              required
              className={`field-input`}
              autoComplete="off"
              type="text"
              name="customerPhone"
              value={formValue.customerPhone}
              onChange={handleInputChange}
            />
          </label> */}
        </form>

        <div className={classes.formAction}>
          <button className={classes.btnCancel} onClick={onClose}>
            ยกเลิก
          </button>
          <button className={classes.btnConfirm} disabled={isDisableBtnSubmit} onClick={onSubmit}>
            ตกลง
          </button>
        </div>
      </div>
    </ReactModal>
  )
}

export default ModalEditCustomerInfo
